import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import moment from 'moment';
import { get } from "../utilities/api";
import Pdf from './Pdf';
import "../styles/result.css";

const Result = ({ client, language, option, result }) => {
    const CONTRACT = "CONTRACT";
    const LICENSE = "LICENSE";

    const { t } = useTranslation();

    const divResult = useRef();
    const divPdf = useRef();

    const [fine, setFine] = useState(null);

    const datePattern = t('ShortDatePattern').toUpperCase();

    useEffect(() => {
        divPdf.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }, []);

    useEffect(() => {
        if (!result) return;

        if (option === "CONTRACT") return;
        handleFineChange(result[0]);
    }, [result, t]);

    useEffect(() => {

        if (!fine) return;

        async function update() {
            const response = await get(language, client, fine.id, fine.enc);
            handleFineChange(response.data);
        }
        update();
    }, [language]);

    const displayDate = (date) => !date ? '' : moment(date).format(datePattern);
    const displayTime = (time) => !time ? '' : `${time.substring(0, 2)}:${time.slice(2)}`;
    const displayValue = (val) => !val ? '' : val;
    const pdfFileName = fine ? `${fine.lp.trim()}-${fine.od.substring(0, 10).replaceAll('-', '')}-${fine.ot}` : "";

    const handlePdfClick = async (index) => {
        const response = await get(language, client, result[index].id, result[index].enc);
        if (response.error) {
            setFine({
                ...result[index], error: t("noresultfound")
            });
            return;
        }
        handleFineChange(response.data);
    };

    const handleFineChange = (data) => {
        setFine({
            ...data,
            error:
                data.ia
                    ? t("isanonymized")
                    : !data.pdf
                        ? t("pdfoldersixmonths")
                        : null
        });
    };

    return (
        <>
            {result && (
                <div className='result' ref={divResult}>
                    <div className={`result-data ${option.toLowerCase()}`}>
                        {option === LICENSE &&
                            <>
                                <div className="row result">
                                    <ResultField label={t("rentalnumber")} value={displayValue(result[0].ra)} />
                                </div>
                                <div className="row result">
                                    <ResultField label={t("reference")} value={displayValue(result[0].rr)} />
                                </div>
                                <div className="row result">
                                    <ResultField label={t("pickupdate")} value={displayDate(result[0].cod)} />
                                    <ResultField label={t("pickuptime")} value={displayTime(result[0].cot)} />
                                    <ResultField label={t("returndate")} value={displayDate(result[0].cid)} />
                                    <ResultField label={t("returntime")} value={displayTime(result[0].cit)} />
                                </div>
                            </>
                        }
                        {option === CONTRACT &&
                            <>
                                {result.map((item, index) => (
                                    <div className="row result" key={index}>
                                        <ResultField label={t("offencedate")} value={displayDate(item.od)} />
                                        <ResultField label={t("offencetime")} value={displayTime(item.ot)} />
                                        <ResultField label={t("pickupdate")} value={displayDate(item.cod)} />
                                        <ResultField label={t("pickuptime")} value={displayTime(item.cot)} />
                                        <ResultField label={t("returndate")} value={displayDate(item.cid)} />
                                        <ResultField label={t("returntime")} value={displayTime(item.cit)} />
                                        <ResultField label={t("reference")} value={displayValue(item.rr)} />
                                        <img alt="PDF" className='pdf-icon' src='images/pdf.svg' onClick={() => handlePdfClick(index)} />
                                    </div>
                                ))}
                            </>
                        }
                    </div>
                </div >
            )
            }

            {fine && fine.error && <div className="alert alert-danger">{fine.error}</div>}
            {fine && fine.pdf && <Pdf pdf={fine.pdf} fileName={pdfFileName} transferLiability={fine.tl} clientName={fine.rn} />}
            <div ref={divPdf}></div>
        </>
    );
};

const ResultField = ({ label, value }) => {
    return (
        <div className="result-wrap">
            <div>{label}</div>
            <div>{value}</div>
        </div>
    );
};

export default Result;
